import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initYandexMetrika, setupRouterTracking } from './analytics/yandex-metrica'

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_YANDEX_METRIKA_ID) {
  initYandexMetrika()
}

setupRouterTracking(router)

const app = createApp(App)
app.use(router)
app.mount('#app')
